import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import api from '../api/api'; // Sua instância do Axios

const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading'); // loading, success, error
    const [message, setMessage] = useState('Verificando sua conta...');

    const token = searchParams.get('token');

    useEffect(() => {
        const verify = async () => {
            if (!token) {
                setStatus('error');
                setMessage('Token de verificação não encontrado.');
                return;
            }

            try {

                await api.get(`/public/auth/verificar?token=${token}`);
                
                setStatus('success');
                setMessage('E-mail confirmado com sucesso!');
                
                // Redireciona para o login após 3 segundos
                setTimeout(() => {
                    navigate('/login?verificado=true');
                }, 3500);

            } catch (error) {
                setStatus('error');
                const errorMsg = error.response?.data || 'Erro ao validar token. Ele pode ter expirado.';
                setMessage(errorMsg);
            }
        };

        verify();
    }, [token, navigate]);

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <div style={styles.iconContainer}>
                    {status === 'loading' && <div style={styles.spinner}></div>}
                    {status === 'success' && <span style={styles.successIcon}>✓</span>}
                    {status === 'error' && <span style={styles.errorIcon}>✕</span>}
                </div>

                <h2 style={styles.title}>
                    {status === 'loading' ? 'Processando...' : 'Verificação de Conta'}
                </h2>
                
                <p style={{...styles.message, color: status === 'error' ? '#ef4444' : '#94a3b8'}}>
                    {message}
                </p>

                {status !== 'loading' && (
                    <Link to="/login" style={styles.button}>
                        Ir para o Login
                    </Link>
                )}
            </div>
        </div>
    );
};

const styles = {
    container: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#020617',
        padding: '20px'
    },
    card: {
        background: 'rgba(255, 255, 255, 0.03)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        padding: '50px 40px',
        borderRadius: '24px',
        maxWidth: '450px',
        width: '100%',
        textAlign: 'center',
        backdropFilter: 'blur(12px)'
    },
    iconContainer: {
        marginBottom: '20px',
        display: 'flex',
        justifyContent: 'center'
    },
    title: {
        fontSize: '1.8rem',
        color: 'white',
        fontWeight: '800',
        marginBottom: '15px'
    },
    message: {
        fontSize: '1.1rem',
        lineHeight: '1.6',
        marginBottom: '30px'
    },
    spinner: {
        width: '50px',
        height: '50px',
        border: '5px solid rgba(16, 185, 129, 0.2)',
        borderTop: '5px solid #10b981',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
    },
    successIcon: {
        fontSize: '50px',
        color: '#10b981',
        background: 'rgba(16, 185, 129, 0.1)',
        width: '80px',
        height: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%'
    },
    errorIcon: {
        fontSize: '50px',
        color: '#ef4444',
        background: 'rgba(239, 68, 68, 0.1)',
        width: '80px',
        height: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%'
    },
    button: {
        display: 'inline-block',
        background: '#10b981',
        color: '#022c22',
        padding: '12px 30px',
        borderRadius: '8px',
        textDecoration: 'none',
        fontWeight: '700',
        transition: '0.3s'
    }
};

// Adicione isso ao seu global.css se ainda não tiver animação de spinner
/*
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
*/

export default VerifyEmail;